import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

/**
 * Tooltip: CommonCriteria
 *
 * @param filters
 * @param getFilter
 * @param getLabel
 * @param getValue
 * @returns {Element}
 * @constructor
 */
export function CommonCriteria({ filters, getFilter, getLabel, getValue }) {
  return (
    <Layout.Stack alignItems="left" alignLayout="left" grow space={Number(themeConfiguration?.theme?.space?.xs) || 4}>
      {filters?.map((filter, index) => {
        return [
          <div key={`filter-name-${filter?.name}`}>
            <Text color="inherit">
              <p>
                <strong>{filter?.name}</strong> (v{filter?.activeVersionNbr})
              </p>
            </Text>
          </div>,
          <Layout.Stack
            alignItems="left"
            alignLayout="left"
            grow
            key={`filter-criteria-${filter?.name}`}
            space={Number(themeConfiguration?.theme?.space?.xs) || 4}
          >
            {filter?.activeCommonCriteriaVersion?.criteria.map((criteriaFilter) => {
              return [
                <div key={`criteria-column-${criteriaFilter?.column}`}>
                  <strong>{getFilter(criteriaFilter?.column)}</strong>
                </div>,
                <div key={`criteria-condition-${criteriaFilter?.condition}`}>
                  <p>{getLabel(criteriaFilter?.condition)}:</p>
                  <Text color="inherit">{getValue(criteriaFilter?.value)}</Text>
                </div>,
              ];
            })}
          </Layout.Stack>,
          index < filters.length - 1 && <Divider />,
        ];
      })}
    </Layout.Stack>
  );
}
